<template>
  <div>
    <query-header-form
      v-for="(model, index) in tokenModels"
      :key="index"
      :model="model"
      :empty-value="emptyValue"
      @remove="remove(model)"
    />

    <div class="card-condition__btn-add">
      <ui-button
        class="justify-end"
        :text="t('Add New Query Header')"
        icon="fas fa-plus"
        button-style="accent"
        @click="add"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import QueryHeaderForm from './query-header-form.vue';
import { useFlowTokenModelsCondition } from './useFlowTokenModelsCondition';

const props = defineProps<{
  conditions: Record<string, Array<{
    values: string[];
    parameter: string;
    predicate: string;
  }>>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, tokenModels, emptyValue, add, remove } = useFlowTokenModelsCondition(
  { conditions: props.conditions, conditionKey: 'queryHeader' },
  emit,
);
</script>

<style lang="scss"></style>
